export enum LibraryType {
    PDF = "pdf",
    AUDIO = "audio",
    VIDEO = "video",
    COURSE = "course",
}

export enum LibraryAccess {
    PAID = "paid",
    FREE = "free",
    PRICED = "priced",
    PLAN = "plan",
    SEGMENT = "segment",
}

export type LibraryItem = {
    type: LibraryType;
    title: string;
    summary: string;
    description: string;
    access: LibraryAccess;
    content_url: string;
    original_file_name: string;
    file_size: number;
    storage_id: string;
    discussion: boolean;
    downloadable: boolean;
    requires_moderation: boolean;
    thumbnail_image?: string | null;
    slug: string;
    plan_ids: Array<any>;
    currency: string;
    visibility: ContentVisibility;
    price: string;
    display_authorized_plans: boolean;
}

export enum ContentType {
    PDF= "pdfs",
    AUDIO = "audios",
    VIDEO = "video",
    COURSE = "courses",
}

export enum ContentVisibility {
    COMMUNITY = "member",
    PUBLIC = "public",
    RESTRICTED = "restricted",
}